/* global $ */
import React, { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import t from '@guestyci/localize/t.macro';

import NavbarAvatar from 'components/NavbarAvatar';
import iconMap from 'icons/iconMap';

const Navbar = ({
  items,
  logo,
  avatar,
  isFixed,
  userName,
  isSmallScreen,
  onLogout,
  history,
  dirty,
  warnDirty,
  onNavigation,
  location,
}) => {
  const onNavLinkClick = (e, to) => {
    $('#navbarSupportedContent').removeClass('hide');

    if (dirty) {
      e.preventDefault();
      warnDirty(to);
    }

    onNavigation(to);
  };

  const [logoImgState, setLogoImgState] = useState(null);

  const onLogoError = () => {
    setLogoImgState({ ...logoImgState, src: iconMap['guesty-logo-gray'] });
  };

  const logoImgRef = (ref) => {
    setLogoImgState(ref);
  };

  const onLogoutCallback = () => {
    onLogout(() => history.push('/'));
  };

  const renderNavLink = ({ getName, href, isDisabled }, i) => {
    const isActive = location.pathname.slice(1) === href;
    const to = `/${href}`;

    const el = isDisabled ? (
      <span className="nav-link disabled">{getName()}</span>
    ) : (
      <Link className="nav-link" to={to} onClick={(e) => onNavLinkClick(e, to)}>
        {getName()}

        {
          // eslint-disable-next-line @guestyci/no-literal-string
          isActive && <span className="sr-only">(current)</span>
        }
      </Link>
    );
    return (
      <li key={i} className={cn('nav-item', { active: isActive })}>
        {el}
      </li>
    );
  };

  const logoImg = (
    <img
      ref={logoImgRef}
      src={logo || iconMap['guesty-logo-gray']}
      alt="logo"
      className="img-fluid"
      onError={onLogoError}
    />
  );
  const logoLink = (
    <Link className="navbar-brand" to="/">
      {logoImg}
    </Link>
  );

  return (
    <nav
      className={cn('navbar navbar-toggleable navbar-light bg-white', {
        'fixed-top': isFixed,
      })}
    >
      <button
        className="navbar-toggler navbar-toggler-right collapsed"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>
      {logoLink}
      <div
        className="collapse navbar-collapse pb-4 pb-sm-0"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav ml-auto">
          {items.map(renderNavLink)}
          {isSmallScreen &&
            renderNavLink(
              { getName: () => t('My profile'), href: 'my-profile' },
              100
            )}
          {isSmallScreen && (
            <li className="nav-item">
              <span
                aria-hidden="true"
                className="nav-link"
                onClick={onLogoutCallback}
              >
                {t('Log out')}
              </span>
            </li>
          )}
        </ul>

        {!isSmallScreen && (
          <div className="ml-47">
            <NavbarAvatar
              src={avatar}
              name={userName}
              onLogout={onLogoutCallback}
            />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
